import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { AnimatePresence, motion, type PanInfo, useReducedMotion } from 'framer-motion';
import type { ReactNode } from 'react';
import { DISMISS_DISTANCE, DISMISS_VELOCITY, DRAWER_EXIT_TRANSITION, DRAWER_TRANSITION } from '@/components/layout/drawer-motion';
type ChatWidgetDocumentsDrawerProps = {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
};

// Not fixed or portaled: iOS Safari tints its toolbars from fixed elements at the screen edges. Stays
// mounted while closed: a chat marker opens it and reveals a resource in the same tick, which a Context
// Explorer mounting on open would miss.
const ChatWidgetDocumentsDrawer = t0 => {
  const $ = _c(31);
  const {
    open,
    onClose,
    children
  } = t0;
  const reduceMotion = useReducedMotion();
  let t1;
  if ($[0] !== reduceMotion) {
    t1 = reduceMotion ? {
      duration: 0
    } : DRAWER_TRANSITION;
    $[0] = reduceMotion;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const enter = t1;
  let t2;
  if ($[2] !== reduceMotion) {
    t2 = reduceMotion ? {
      duration: 0
    } : DRAWER_EXIT_TRANSITION;
    $[2] = reduceMotion;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const exit = t2;
  let t3;
  if ($[4] !== onClose) {
    t3 = (_, t4) => {
      const {
        offset,
        velocity
      } = t4;
      if (offset.x > DISMISS_DISTANCE || velocity.x > DISMISS_VELOCITY) {
        onClose();
      }
    };
    $[4] = onClose;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  const handleDragEnd = t3;
  let t4;
  if ($[6] !== enter || $[7] !== exit || $[8] !== onClose || $[9] !== open) {
    t4 = open && <motion.button type="button" aria-hidden={true} tabIndex={-1} initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0,
      pointerEvents: "none",
      transition: exit
    }} transition={enter} onClick={onClose} className="pointer-events-auto absolute inset-0 bg-(--overlay-backdrop)" />;
    $[6] = enter;
    $[7] = exit;
    $[8] = onClose;
    $[9] = open;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <AnimatePresence>{t4}</AnimatePresence>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const t6 = open ? 0 : "100%";
  const t7 = open ? "visible" : "hidden";
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = {
      x: t6,
      visibility: t7
    };
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const t9 = open ? enter : exit;
  let t10;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      left: 0,
      right: 0
    };
    t11 = {
      left: 0,
      right: 1
    };
    $[16] = t10;
    $[17] = t11;
  } else {
    t10 = $[16];
    t11 = $[17];
  }
  const t12 = !open;
  const t13 = !open;
  const t14 = open && "pointer-events-auto";
  let t15;
  if ($[18] !== t14) {
    t15 = cx("absolute inset-y-0 right-0 w-[min(20rem,calc(100%-4rem))] overflow-hidden rounded-l-2xl bg-primary pb-[env(safe-area-inset-bottom)] shadow-lg", t14);
    $[18] = t14;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== children || $[21] !== handleDragEnd || $[22] !== t12 || $[23] !== t13 || $[24] !== t15 || $[25] !== t8 || $[26] !== t9) {
    t16 = <motion.div initial={false} animate={t8} transition={t9} drag="x" dragConstraints={t10} dragElastic={t11} dragMomentum={false} onDragEnd={handleDragEnd} aria-hidden={t12} inert={t13} className={t15}>{children}</motion.div>;
    $[20] = children;
    $[21] = handleDragEnd;
    $[22] = t12;
    $[23] = t13;
    $[24] = t15;
    $[25] = t8;
    $[26] = t9;
    $[27] = t16;
  } else {
    t16 = $[27];
  }
  let t17;
  if ($[28] !== t16 || $[29] !== t5) {
    t17 = <div className="pointer-events-none absolute inset-0 z-30">{t5}{t16}</div>;
    $[28] = t16;
    $[29] = t5;
    $[30] = t17;
  } else {
    t17 = $[30];
  }
  return t17;
};
export default ChatWidgetDocumentsDrawer;